"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, others = tslib_1.__rest(_a, ["theme", "className"]);
    return (React.createElement("div", tslib_1.__assign({}, others, { className: classnames_1.default(theme.infocon, className) }),
        React.createElement("div", { className: theme.text }, "?")));
});
